<template>
  <section class="retrieval-section">
    <header class="retrieval-section-header">
      <div class="icon-list">
        <div class="icon-list-item"></div>
        <div class="icon-list-item"></div>
        <div class="icon-list-item"></div>
      </div>
      <div class="retrieval-section-header-title">{{$t('retrieval.retrieval')}}</div>
    </header>
    <main class="retrieval-section-container">
      <div class="top">
        <div class="top-search-warp">
          <div class="left">
            <el-input size="small" v-model="keyword" clearable
                      :placeholder="$t('retrieval.retrievalTips')" @input="handleInput"
                      @keyup.enter.native="handleRetrieval">
            </el-input>
            <el-button class="search-btn" type="primary" @click="handleRetrieval">
              {{$t('retrieval.retrieval')}}</el-button>
          </div>
          <div class="right" @click="settingStatus=!settingStatus">
            <span>{{$t('newProjectV2.advancedSetting')}}</span>
            <i :class="[settingStatus?'setting-open':'setting-fold']"
               class="el-icon-arrow-down"></i>
          </div>
        </div>
        <!-- 高级设置 -->
        <retrieval-setting v-model="filter" :visible="settingStatus"></retrieval-setting>
        <el-divider></el-divider>
      </div>
      <div class="bottom"
           :style="{'height':settingStatus?'calc(100% - 8.85em)':'calc(100% - 5.14em)'}">
        <!-- 检索结果 -->
        <retrieval-result-container v-if="isSearch" :keyword="keyword" :data="queryList"
                                    :pagingInfo="pagingInfo" @handleScrollList="handleScrollList">
        </retrieval-result-container>
        <!-- 历史记录 -->
        <retrieval-history v-if="!isSearch" :data="historyRetrievalList"
                           @handleRetrievalHistory="handleRetrievalHistory"
                           @handleClearHistory="handleClearHistory"></retrieval-history>
      </div>
    </main>
  </section>
</template>
<script>
import 'element-ui/lib/theme-chalk/base.css'
import RetrievalSetting from '../components/retrievalSetting.vue';
import RetrievalHistory from '../components/retrievalHistory.vue';
import RetrievalResultContainer from '../components/retrievalResultContainer.vue';
import { removeProperty } from '@/utils';
import { getSearchResult } from '@/services/memoryBank';
// import _ from 'lodash'
export default {
  name: "Retrieval",
  components: {
    RetrievalSetting,
    RetrievalHistory,
    RetrievalResultContainer
  },
  data() {
    return {
      // 高级设置 展开|折叠
      settingStatus: false,
      queryList: [],
      keyword: '',
      filter: {
        corpusType: 0,
        sourceLang: '',
        targetLang: '',
        domainCode: '',
        companyCode: localStorage.getItem("companyCode"),
      },
      queryParams: {
        page: 1,
        rows: 10,
      },
      pagingInfo: {
        totalRows: 0,
        totalPage: 0,
        sentCount:0
      },
      historyRetrievalList: [],
      isSearch: false
    }
  },
  watch: {
    filter: {
      handler(newVal) {
        if (!newVal) return
        if (!this.keyword) return
        this.queryList = []
        this.queryParams.page = 1
        this.getList()
      },
      deep: true
    }
  },
  created() {
    this.historyRetrievalList = JSON.parse(localStorage.getItem('historyRetrieval')) || []
  },
  computed: {

  },
  methods: {
    handleInput() {
      if (!this.keyword) {
        this.isSearch = false;
      }
    },
    // 点击检索
    async handleRetrieval() {
      if (!this.keyword) return
      this.isSearch = true;
      this.queryParams.page = 1
      this.queryList = []
      await this.getList()
      // 历史记录处理
      let arr = JSON.parse(localStorage.getItem('historyRetrieval')) || []
      arr = arr.filter(item => item.keyword !== this.keyword)
      arr.unshift({ ...this.filter, keyword: this.keyword })
      this.historyRetrievalList = JSON.parse(JSON.stringify(arr))
      localStorage.setItem('historyRetrieval', JSON.stringify(arr))
    },
    // 获取检索列表
    async getList() {
      const params = {
        filter: removeProperty({ ...this.filter }),
        page: this.queryParams.page,
        rows: this.queryParams.rows
      }
      params.filter.keyword = this.keyword
      Reflect.set(params.filter, 'sourceAppid', '')
      const { result, success } = await getSearchResult(params)
      if (!success) return
      const { corpusLibList, totalPage, totalRows, sentCount } = result
      this.queryList = [...this.queryList, ...corpusLibList]
      this.pagingInfo.totalRows = totalRows
      this.pagingInfo.totalPage = totalPage
      this.pagingInfo.sentCount = sentCount
    },
    // 滚动加载列表
    handleScrollList() {
      if (this.queryParams.page < this.pagingInfo.totalPage) {
        this.queryParams.page += 1
        this.getList()
      }
    },
    // 检索历史
    handleRetrievalHistory(data) {
      this.keyword = data
      this.queryParams.page = 1
      this.queryList = []
      this.getList()
      this.isSearch = true;
    },
    handleClearHistory() {
      this.historyRetrievalList = []
      localStorage.setItem('historyRetrieval', JSON.stringify([]))
    }
  }
}
</script>
<style lang="less" scoped>
@import "./style/index.less";
</style>